import React, { useEffect, useState } from 'react';
import mammoth from 'mammoth';

interface WordViewerProps {
  fileUrl: string;
  zoom: number;
}

const WordViewer: React.FC<WordViewerProps> = ({ fileUrl, zoom }) => {
  const [htmlContent, setHtmlContent] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    const loadDocument = async () => {
      try {
        setLoading(true);
        setError('');

        // Télécharger le fichier
        const response = await fetch(fileUrl);
        const arrayBuffer = await response.arrayBuffer();

        // Convertir en HTML avec mammoth
        const result = await mammoth.convertToHtml({ arrayBuffer });
        setHtmlContent(result.value);
      } catch (err) {
        setError('Erreur lors du chargement du document Word');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadDocument();
  }, [fileUrl]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-96">
        <p className="text-red-600">{error}</p>
      </div>
    );
  }

  return (
    <div
      className="bg-white p-8 rounded-lg shadow-sm mx-auto max-w-4xl"
      style={{ transform: `scale(${zoom / 100})`, transformOrigin: 'top center' }}
    >
      <div
        className="prose prose-sm max-w-none"
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    </div>
  );
};

export default WordViewer;
